const CompanySettingTypes = {
  EmailsReplyTo: 'emails_reply_to',
  EmailAutomationEnabled: 'email_automation_enabled',
  ReportsHideNonPolicyHolders: 'reports_hide_non_policy_holders',
  IncludeRecordAndInsuredContactInfoInEmailTools: 'include_record_and_insured_contact_info_in_email_tools',
  IncludeAgentInfoInEmailTools: 'include_agent_info_in_email_tools',
  RequireAgentDetails: 'require_agent_details',
  AutoArchiveExpiredDocuments: 'auto_archive_expired_documents',
  AgentSubmissionNameDisplay: 'agent_submission_name_display',
  AgentSubmissionEmailDisplay: 'agent_submission_email_display',
  AgentSubmissionPhoneDisplay: 'agent_submission_phone_display'
};

export default CompanySettingTypes;
